import { render } from "./Acessorios.vue?vue&type=template&id=77c8cad5"
import script from "./Acessorios.vue?vue&type=script&lang=js"
export * from "./Acessorios.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__